module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rpre"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253049896_Preface"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253049896_Ack"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253049896_Chapter_1"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "space_1"
  }, [_c('b', [_vm._v("PIONEER RAILROAD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049896_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "space_1"
  }, [_c('b', [_vm._v("EXPANSION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049896_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "space_1"
  }, [_c('b', [_vm._v("ROBBER BARONS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049896_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "space_1"
  }, [_c('b', [_vm._v("ROUGH TRACKS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049896_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "space_1"
  }, [_c('b', [_vm._v("FARRINGTON ERA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049896_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "space_1"
  }, [_c('b', [_vm._v("SAVING THE ROCK")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_c",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049896_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "space_1"
  }, [_c('b', [_vm._v("LIQUIDATION AND LEGACY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rnot"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049896_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253049896_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e26bd388","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253049896_Contents.vue
// module id = 72
// module chunks = 0